import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var HidratacionService = /** @class */ (function () {
    function HidratacionService(http) {
        this.http = http;
        this.cargadoHidratacion = true;
        this.hidratacion = [];
        this.hidratacionRFL = [];
        this.hidratacionRFC = [];
        this.hidratacionRFP = [];
        this.hidratacionRCL = [];
        this.hidratacionRCC = [];
        this.hidratacionRCP = [];
        this.cargarHidratacion();
    }
    HidratacionService.prototype.cargarHidratacion = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.http.get('assets/data/dataLineas.json')
                .subscribe(function (resp) {
                _this.hidratacion = resp;
                _this.hidratacionRFL = _this.hidratacion[12].rutinafacial.limpieza;
                _this.hidratacionRFC = _this.hidratacion[12].rutinafacial.cuidado;
                _this.hidratacionRFP = _this.hidratacion[12].rutinafacial.proteccion;
                _this.hidratacionRCL = _this.hidratacion[12].rutinacorporal.limpieza;
                _this.hidratacionRCC = _this.hidratacion[12].rutinacorporal.cuidado;
                _this.hidratacionRCP = _this.hidratacion[12].rutinacorporal.proteccion;
                setTimeout(function () {
                    _this.cargadoHidratacion = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    };
    HidratacionService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    HidratacionService = tslib_1.__decorate([
        Injectable({
            providedIn: 'root'
        })
    ], HidratacionService);
    return HidratacionService;
}());
export { HidratacionService };
//# sourceMappingURL=hidratacion.service.js.map